import {useState} from 'react'
import {BasicBreadcrumbs} from 'src/app/shared/BasicBreadcrumbs'
import {KTCard} from '../../../../_metronic/helpers'
import {UsersReportContext} from './UsersReportContext'
import {UsersReportTable} from './main/UsersReportTable'
import {UsersReportTableHeader} from './main/UsersReportTableHeader'

const usersReportBreadcrumbs = [
  {
    title: 'Reportes',
    path: '/reportes/usuarios',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const UsersReportPage = () => {
  const [processId, setProcessId] = useState('')
  const [dateRange, setDateRange] = useState<string[]>([])
  const [documentNumber, setDocumentNumber] = useState('')
  const [userName, setUserName] = useState('')
  const [data, setData] = useState<any>([])
  const [isLoading, setLoadingStatus] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [selectedUsers, setSelectedUsers] = useState<string[]>([])
  const [sortBy, setSortBy] = useState<{columnName: string; sortDirection: string}>({
    columnName: '',
    sortDirection: '',
  })

  const usersReportValue = {
    processId,
    setProcessId,
    dateRange,
    setDateRange,
    documentNumber,
    setDocumentNumber,
    userName,
    setUserName,
    data,
    setData,
    isLoading,
    setLoadingStatus,
    currentPage,
    setCurrentPage,
    totalPages,
    setTotalPages,
    selectedUsers,
    setSelectedUsers,
    sortBy,
    setSortBy, // Añadido
  }

  return (
    <UsersReportContext.Provider value={usersReportValue}>
      <BasicBreadcrumbs breadcrumbs={usersReportBreadcrumbs} fallbackTitle='Reporte de Usuarios' />
      <KTCard className='overflow-visible'>
        <UsersReportTableHeader />
        <UsersReportTable />
      </KTCard>
    </UsersReportContext.Provider>
  )
}

export {UsersReportPage}
